"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PAGINATION_POSITION;
(function (PAGINATION_POSITION) {
    PAGINATION_POSITION[PAGINATION_POSITION["Left"] = 0] = "Left";
    PAGINATION_POSITION[PAGINATION_POSITION["Right"] = 1] = "Right";
    PAGINATION_POSITION[PAGINATION_POSITION["Center"] = 2] = "Center";
})(PAGINATION_POSITION || (PAGINATION_POSITION = {}));
var BasicPagination = /** @class */ (function (_super) {
    __extends(BasicPagination, _super);
    function BasicPagination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BasicPagination.prototype.getPaginationPosition = function () {
        var _a = this.props, currentPageIndex = _a.currentPageIndex, pageCount = _a.pageCount, maxSidePageCount = _a.maxSidePageCount;
        if (currentPageIndex < maxSidePageCount - 1) {
            return PAGINATION_POSITION.Left;
        }
        if (currentPageIndex > pageCount - maxSidePageCount) {
            return PAGINATION_POSITION.Right;
        }
        return PAGINATION_POSITION.Center;
    };
    BasicPagination.prototype.getIndexRangeForBreaker = function (position) {
        var _a = this.props, currentPageIndex = _a.currentPageIndex, pageCount = _a.pageCount, minimum = _a.minimum;
        switch (position) {
            case PAGINATION_POSITION.Left:
                return [Math.max(minimum, currentPageIndex + 2), pageCount - 1];
            case PAGINATION_POSITION.Right:
                return [1, Math.min(currentPageIndex - 1, pageCount - minimum)];
            case PAGINATION_POSITION.Center:
            default:
                // this method should not be used for central position
                return null;
        }
    };
    BasicPagination.prototype.renderPageMarker = function (index) {
        var _a = this.props, renderPageButton = _a.renderPageButton, currentPageIndex = _a.currentPageIndex, setIndex = _a.setIndex;
        var clickCallback = function () { return setIndex(index); };
        return (react_1.default.createElement(react_1.Fragment, { key: index }, renderPageButton({
            index: index,
            text: index + 1,
            highlight: index === currentPageIndex,
            onClick: clickCallback,
        })));
    };
    BasicPagination.prototype.renderBreaker = function (index) {
        var renderBreakView = this.props.renderBreakView;
        return (react_1.default.createElement(react_1.Fragment, { key: index }, renderBreakView({
            index: index,
        })));
    };
    BasicPagination.prototype.getCentralPositionPagination = function () {
        var _a = this.props, currentPageIndex = _a.currentPageIndex, headTailCount = _a.headTailCount, pageCount = _a.pageCount, numberOfCentralPagesToShow = _a.numberOfCentralPagesToShow;
        var breakView;
        var pageMarkers = [];
        for (var index = 0; index < pageCount; index += 1) {
            var numberOfPagesToShow = numberOfCentralPagesToShow - 1;
            switch (index) {
                case headTailCount:
                    breakView = this.renderBreaker(index);
                    pageMarkers.push(breakView);
                    index = currentPageIndex - numberOfPagesToShow;
                    break;
                case currentPageIndex + numberOfPagesToShow:
                    breakView = this.renderBreaker(index);
                    pageMarkers.push(breakView);
                    index = pageCount - headTailCount - 1;
                    break;
                default:
                    pageMarkers.push(this.renderPageMarker(index));
            }
        }
        return pageMarkers;
    };
    BasicPagination.prototype.getSidePositionPagination = function (position) {
        var indexForBreaker = this.getIndexRangeForBreaker(position);
        var breakView;
        var pageMarkers = [];
        var pageCount = this.props.pageCount;
        for (var index = 0; index < pageCount; index += 1) {
            var isLastItemBreaker = pageMarkers[pageMarkers.length - 1] === breakView;
            var isIndexToInsertBreaker = indexForBreaker && index === indexForBreaker[0];
            if (isIndexToInsertBreaker && !isLastItemBreaker) {
                breakView = this.renderBreaker(index);
                pageMarkers.push(breakView);
                index = indexForBreaker[1] - 1;
            }
            else {
                pageMarkers.push(this.renderPageMarker(index));
            }
        }
        return pageMarkers;
    };
    BasicPagination.prototype.getPaginationForLowNumberOfPages = function () {
        var pageCount = this.props.pageCount;
        var pageMarkers = [];
        for (var index = 0; index < pageCount; index += 1) {
            pageMarkers.push(this.renderPageMarker(index));
        }
        return pageMarkers;
    };
    BasicPagination.prototype.getPageNumbers = function () {
        var _a = this.props, pageCount = _a.pageCount, maxSidePageCount = _a.maxSidePageCount;
        var position = this.getPaginationPosition();
        if (pageCount <= maxSidePageCount) {
            return this.getPaginationForLowNumberOfPages();
        }
        if (position === PAGINATION_POSITION.Center) {
            return this.getCentralPositionPagination();
        }
        return this.getSidePositionPagination(position);
    };
    BasicPagination.prototype.render = function () {
        return this.getPageNumbers();
    };
    BasicPagination.defaultProps = {
        maxSidePageCount: 5,
        minimum: 3,
        headTailCount: 1,
        numberOfCentralPagesToShow: 3,
    };
    return BasicPagination;
}(react_1.Component));
exports.default = BasicPagination;
//# sourceMappingURL=BasicPagination.js.map